import styled, { css } from 'styled-components'
import Loader from './index'

const FullSize = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    ${({ suspense }) => suspense && css`
        height: 100vh;
    `};
    justify-content: center;
    align-items: center;
`
const LoaderFullScreen = ({ suspense }) => {

    return (
        <FullSize suspense={suspense}>
            <Loader />
        </FullSize>
    )

}

export default LoaderFullScreen